import {
    primaryColor,
    grayColor,
  } from "assets/jss/material-kit-pro-react.js";

import imagesStyles from "assets/jss/material-kit-pro-react/imagesStyles.js";

const imgRaised = imagesStyles.imgRaised;

const userBadgeStyle = {
    primaryColor,
    imgRaised,
    user: {
        display: "inline-flex",
        "& a": {
          color: grayColor[1]
        }
    },
    cursor: {
      cursor: "pointer"
    },
    noShadow: {
      boxShadow: 'none'
    },
    avatarXs: {
      width: "15px",
      height: "15px",
      minWidth: "15px",
      minHeight: "15px",
      overflow: "hidden",
      borderRadius: "50%",
      marginRight: "5px",
      marginTop: "-2px"
    },
    avatarSm: {
        width: "20px",
        height: "20px",
        minWidth: "20px",
        minHeight: "20px",
        overflow: "hidden",
        borderRadius: "50%",
        marginRight: 5,
        marginTop: "-2px"
    },
    avatarMd: {
      width: "39px",
      height: "39px",
      minWidth: "39px",
      minHeight: "39px",
      overflow: "hidden",
      borderRadius: "50%",
      marginRight: "5px",
      marginTop: "-2px"
    },
    avatarLg: {
      width: "60px",
      height: "60px",
      minWidth: "60px",
      minHeight: "60px",
      overflow: "hidden",
      borderRadius: "50%",
      marginRight: 20,
      marginTop: "-2px"
    },
    nameText: {
      fontWeight: "bold",
      marginLeft: 7
    },
    noMargins: {
      margin: "0px!important"
    },
    border: {
      border: "1px solid white",
      borderRadius: "50%",
    },
    titleText: {
      display: 'block',
      marginLeft: 5,
      fontStyle: 'italic'
    }
};

export default userBadgeStyle;